import { Award, MapPin, Phone, Mail, Globe } from "lucide-react";
import Reveal from "@/components/Reveal";
import { FAZZENDA_AWARDS, FAZZENDA_OFFICIAL } from "@/data/resorts";

export function AwardsStrip() {
    return (
        <section className="border-b border-[#E5DEC9] bg-white py-10" data-testid="awards-strip">
            <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-4 sm:flex-row sm:justify-center sm:gap-14 sm:px-6">
                <span className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-stone-400">
                    <Award className="h-4 w-4 text-gold-hover" />
                    Reconhecimentos
                </span>
                {FAZZENDA_AWARDS.map((a) => (
                    <img
                        key={a.label}
                        src={a.img}
                        alt={a.label}
                        title={a.label}
                        loading="lazy"
                        className="h-16 w-auto object-contain opacity-80 transition-opacity duration-300 hover:opacity-100 sm:h-20"
                    />
                ))}
            </div>
        </section>
    );
}

export function OfficialInfo() {
    return (
        <section className="bg-sand pb-24" data-testid="official-info">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <Reveal>
                    <div className="grid grid-cols-1 gap-4 rounded-3xl border border-[#E5DEC9] bg-white p-7 sm:grid-cols-2 lg:grid-cols-4 sm:p-8">
                        <a href={FAZZENDA_OFFICIAL.maps} target="_blank" rel="noopener noreferrer" data-testid="official-address" className="flex items-start gap-3 transition-colors hover:text-gold-hover">
                            <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-forest-emerald" />
                            <span>
                                <span className="block text-[11px] font-semibold uppercase tracking-[0.16em] text-stone-400">Endereço oficial</span>
                                <span className="mt-1 block text-sm font-medium text-forest-deep">{FAZZENDA_OFFICIAL.address}</span>
                            </span>
                        </a>
                        <a href={`tel:+55${FAZZENDA_OFFICIAL.phone.replace(/\D/g, "")}`} data-testid="official-phone" className="flex items-start gap-3 transition-colors hover:text-gold-hover">
                            <Phone className="mt-0.5 h-5 w-5 shrink-0 text-forest-emerald" />
                            <span>
                                <span className="block text-[11px] font-semibold uppercase tracking-[0.16em] text-stone-400">Central do resort</span>
                                <span className="mt-1 block text-sm font-medium text-forest-deep">{FAZZENDA_OFFICIAL.phone}</span>
                            </span>
                        </a>
                        <a href={`mailto:${FAZZENDA_OFFICIAL.email}`} data-testid="official-email" className="flex items-start gap-3 transition-colors hover:text-gold-hover">
                            <Mail className="mt-0.5 h-5 w-5 shrink-0 text-forest-emerald" />
                            <span>
                                <span className="block text-[11px] font-semibold uppercase tracking-[0.16em] text-stone-400">E-mail</span>
                                <span className="mt-1 block text-sm font-medium text-forest-deep">{FAZZENDA_OFFICIAL.email}</span>
                            </span>
                        </a>
                        <a href={FAZZENDA_OFFICIAL.site} target="_blank" rel="noopener noreferrer" data-testid="official-site" className="flex items-start gap-3 transition-colors hover:text-gold-hover">
                            <Globe className="mt-0.5 h-5 w-5 shrink-0 text-forest-emerald" />
                            <span>
                                <span className="block text-[11px] font-semibold uppercase tracking-[0.16em] text-stone-400">Site oficial</span>
                                <span className="mt-1 block text-sm font-medium text-forest-deep">fazzenda.com.br</span>
                            </span>
                        </a>
                    </div>
                    <p className="mt-4 text-center text-[11px] text-stone-400">{FAZZENDA_OFFICIAL.note}</p>
                </Reveal>
            </div>
        </section>
    );
}
